import { render, staticRenderFns } from "./ForgotPasswordSheet.vue?vue&type=template&id=391fc194&scoped=true"
import script from "./ForgotPasswordSheet.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSheet.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordSheet.vue?vue&type=style&index=0&id=391fc194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391fc194",
  null
  
)

export default component.exports